<!-- =========================================================================================
	File Name: TableMiscellaneous.vue
	Description: Combine filter,sorter, pagination etc.
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Version: 1.1
	Author: Pixinvent
	Author URL: hhttp://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card>
    <div class="page">
      <div
        class="grid-layout-container alignment-block"
        style="vertical-align:text-top ;width:100%; margin-bottom:2.7mm;"
        v-for="(item, index) in rowItems"
        :key="index"
      >
        <div v-if="pb(index , LINEPERPAGE, 1)" style="margin-top: 2mm;"></div>
        <vs-row v-if="index < ROWS" vs-w="12">
          <vs-col
            v-for="(colitem, colind) in colItems"
            :key="colind"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            style="width: 20%;"
          >
            <div
              v-if="((index) * COLS) + colind >= SPACE"
              class="grid-layout-container alignment-block theborder"
              style="vertical-align:text-top ;"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <b>{{item.customerName}}</b>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <b>โทร : {{item.customerPhone}}</b>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <b>{{ formatDate(item.pickupDate)}} ~ {{ formatDate(item.returnDate)}}</b>
              </vs-row>
            </div>
            <div
              v-else
              class="grid-layout-container alignment-block theborder"
              style="vertical-align:text-top ;"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <!-- <b>{{item.customerName}}</b> -->
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <!-- <b>โทร : {{item.customerPhone}}</!-->
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <!-- {{ formatDate(item.pickupDate)}} ~ {{ formatDate(item.returnDate)}} -->
              </vs-row>
            </div>
          </vs-col>
        </vs-row>

        <vs-row v-else vs-w="12">
          <vs-col
            v-for="(colitem, colind) in remainderItems"
            :key="colind"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            style="width: 20%;"
          >
            <div
              v-if="((index) * COLS) + colind >= SPACE"
              class="grid-layout-container alignment-block theborder"
              style="vertical-align:text-top ;"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <b>{{item.customerName}}</b>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <b>โทร : {{item.customerPhone}}</b>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <b>{{ formatDate(item.pickupDate)}} ~ {{ formatDate(item.returnDate)}}</b>
              </vs-row>
            </div>
            <div
              v-else
              class="grid-layout-container alignment-block theborder"
              style="vertical-align:text-top ;"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <!-- <b>{{item.customerName}}</b> -->
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <!-- <b>โทร : {{item.customerPhone}}</!-->
              </vs-row>
              <vs-row vs-type="flex" vs-justify="center" vs-w="12" style="width:100% !important;">
                <!-- {{ formatDate(item.pickupDate)}} ~ {{ formatDate(item.returnDate)}} -->
              </vs-row>
            </div>
          </vs-col>
        </vs-row>
        <div v-if="pb(index , LINEPERPAGE, 0)" class="pagebreak"></div>
      </div>
    </div>
  </vx-card>
</template>

<script>
// import Receipt from "./Receipt.vue";
import Prism from "vue-prism-component";
import shapeFormat from "../../mixins/shapeFormat.js";
export default {
  mixins: [shapeFormat],
  data() {
    return {
      products: [],
      orderHeaderId: "",
      watermark: true,
      dlist: [],
      orderheader: {},
      position: 0,
      COLS: 5,
      ROWS: 0,
      LINEPERPAGE: 12,
      ALLS: 60,
      REMAINDER: 0,
      totalRecty: 0, // จำนวน sticker + เว้นว่าง
      SPACE: 0, // จำนวนเว้นว่าง
      COUNTINDEX: 0,
      rowItems: [],
      colItems: [],
      remainderItems: []
    };
  },
  created() {
    this.orderHeaderId = this.$route.params.orderid;
    // var wm = this.$route.params.watermark;
  },
  async mounted() {
    this.orderheader = await this.loadOrder(this.orderHeaderId);
    var dlist_tmp = await this.loadDetail(this.orderHeaderId);
    this.products = await this.loadAllProduct();
    this.dlist = await dlist_tmp.filter(yy => yy.flag1 !== "y");

    var newlist = [];
    // ไม่เอา category => 'F'
    for (var ind = 0; ind < this.dlist.length; ind++) {
      var item = await this.products.find(
        x => x.productItemId === this.dlist[ind].productItemId
      );
      if (item.category !== "F" && item.category !== "B") {
        await newlist.push(this.dlist[ind]);
      }
    }

    this.dlist = await newlist;

    var recty = await this.dlist.length;

    this.position = await this.getOne(
      "/api/systemconfig/getsticker/" + this.orderheader.branchId,
      this.$store.state.auth.apiHeader
    );

    console.log("position : ", this.position);

    this.SPACE = await (this.position - 1);

    this.totalRecty = await (recty + this.SPACE);

    this.ROWS = Math.floor(this.totalRecty / this.COLS);
    this.REMAINDER = this.totalRecty - this.ROWS * this.COLS;
    // MAKE ROWS

    for (var i = 0; i < this.ROWS + 1; i++) {
      await this.rowItems.push(this.orderheader);
    }

    // MAKE COLS
    for (var k = 0; k < this.COLS; k++) {
      await this.colItems.push(this.orderheader);
    }

    for (var r = 0; r < this.REMAINDER; r++) {
      await this.remainderItems.push(this.orderheader);
    }

    await this.loadPosition(recty, this.ALLS, this.orderheader.branchId);

    setTimeout(() => {
      window.print();
    }, 2500);
  },
  methods: {
    pb(ind, lpp, rem) {
      var remd = ind + 1 - Math.floor((ind + 1) / lpp) * lpp;

      if (remd === rem) {
        return true;
      } else {
        return false;
      }
    },
    async loadPosition(num, maxnum, branchId) {
      var response = null;
      try {
        response = await this.$http.get(
          this.$store.state.apiURL +
            "/api/systemconfig/sticker/" +
            num.toString() +
            "/" +
            maxnum.toString() +
            "/" +
            branchId,
          this.$store.state.auth.apiHeader
        );
      } catch (error) {
        this.noticeError(error);
        return null;
      }

      return await response.data;
    },

    async loadDetail(orderid) {
      var response = null;
      try {
        response = await this.$http.get(
          this.$store.state.apiURL + "/api/orderdetail/" + orderid,
          this.$store.state.auth.apiHeader
        );
      } catch (error) {
        return null;
      }

      return await response.data;
    },
    async loadAllProduct() {
      var response = null;
      try {
        response = await this.$http.get(
          this.$store.state.apiURL + "/api/productitem",
          this.$store.state.auth.apiHeader
        );
      } catch (error) {
        return null;
      }

      return await response.data;
    },
    async loadOrder(orderid) {
      var response;
      try {
        response = await this.$http.get(
          this.$store.state.apiURL + "/api/orderheader/" + orderid,
          this.$store.state.auth.apiHeader
        );
      } catch (error) {
        return null;
      }

      return await response.data;
    }
  },
  components: {
    Prism
  }
};
</script>
<style>
.theborder {
  /* border: solid 1px black; */
  width: 38mm;
  height: 22mm;
  font-size: 9px;
  align-content: center;
  padding-top: 17px;
}

.page {
  width: 210mm;
  min-height: 295mm;
  padding: 0 4mm;
  margin: 0 auto;
  border: 1px #d3d3d3 solid;
  /* border-radius: 5px; */
  background: white;
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
}
@page {
  size: A4;
  margin: 0;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 295mm;
  }
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    height: initial;
    box-shadow: initial;
    background: initial;
    /* page-break-after: always; */
  }
}

.vx-card {
  padding-top: 0 !important;
  box-shadow: none !important;
  height: 295mm !important;
}

.vx-card__body {
  padding: 0 !important;
  background-color: white !important;
  height: 295mm !important;
}

@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
</style>
